import {createSlice, PayloadAction} from '@reduxjs/toolkit';

const initialState: IAdvertisementRegisteration = {
  // ad_type: {title: 'آگهی شخصی', value: 'personal'},
};

export const registerAdvertisementSlice = createSlice({
  name: 'advertisementRegisteration',
  initialState,
  reducers: {
    addAddType: (
      state,
      action: PayloadAction<{title: string; value: string}>,
    ) => {
      state.ad_type = action.payload;
    },
    prevRoute: (state, action: PayloadAction<string>) => {
      state.prevRoute = action.payload;
    },
    clearPrevRoute: state => {
      state.prevRoute = null;
    },
    addFormData: (state, action: PayloadAction<string>) => {
      state.formData = action.payload;
    },
    isSendingData: (state, action: PayloadAction<boolean>) => {
      state.isSendingData = action.payload;
    },
    addOptionalFormData: (state, action: PayloadAction<string>) => {
      state.optionalFormData = action.payload;
    },
    addRegisterAdvertisement: (
      state,
      action: PayloadAction<IAdvertisementRegisteration>,
    ) => {
      Object.keys(action.payload).map(item => {
        //@ts-ignore
        return (state[item] = action.payload[item]);
      });
    },
    resetRegisterAdvertisement: (
      state,
      action: PayloadAction<IAdvertisementRegisteration>,
    ) => {
      // state.ad_type = undefined;
      state.srs_type = undefined;
      state.input_group = undefined;
      state.mode = undefined;
      state.input = undefined;
      state.sub_input = undefined;
      state.title = undefined;
      state.sub_brand_data = undefined;
      state.brand_name = undefined;
      state.price = undefined;
      state.price_on_call = undefined;
      // state.images = undefined;
      // state.main_image = action.payload.main_image;
    },
    resetAllAdvertisementData: () => initialState,
    resetOptionalFormData: (state, action: PayloadAction<string>) => {
      state.optionalFormData = '';
    },
    resetFormData: (state, action: PayloadAction<string>) => {
      state.formData = '';
      state.price = '';
      state.quantity_pack = undefined;
      state.quantity_pack_unit = undefined;
      state.min_sell_quantity = undefined;
      state.application_method = undefined;
      state.combinations = undefined;
      state.description = undefined;
      state.available_quantity = undefined;
      state.has_no_brand = false;
    },
    clearBrandData: state => {
      state.sub_brand_data = undefined;
      state.brand_name = undefined;
      state.price = '';
      state.title = undefined;
      state.main_image = undefined;
      state.description = undefined;
    },
  },
});

export const {
  addRegisterAdvertisement,
  resetRegisterAdvertisement,
  resetAllAdvertisementData,
  clearBrandData,
  addFormData,
  addOptionalFormData,
  resetOptionalFormData,
  resetFormData,
  addAddType,
  isSendingData,
  prevRoute,
} = registerAdvertisementSlice.actions;

export default registerAdvertisementSlice.reducer;
